<template>
    <div :class="$attrs.class">
        <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
        <input :id="id" ref="input" v-bind="{ ...$attrs, class: null }" class="form-checkbox" :class="[{ error: error }, checkboxClass]"
               :type="type" :checked="modelValue" @change="$emit('update:modelValue', $event.target.checked)"/>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import {v4 as uuid} from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'checkbox',
        },
        checkboxClass: {
            type: String,
            default: '',
        },
        error: String,
        label: String,
        modelValue: {
            type: [Boolean, Number],
            default: false,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
